import { path } from '@/router'
import { bonusTypes } from '@/services/resources'

export const bonusUrls = {
  [bonusTypes.money]: path?.moneyBonuses,
  [bonusTypes.refill]: path?.refillBonuses
}
